import React, { useState } from 'react';
import { usePackagingOperationsContext } from '../context/PackagingOperationsContext';

const CorrectiveActionComponent: React.FC = () => {
    const { state, dispatch } = usePackagingOperationsContext();
    const [actions, setActions] = useState<Record<number, string>>({});

    const handleSubmit = () => {
        // Dispatch actions to context if needed
        dispatch({ type: 'SET_STATE', payload: 'PENDING_REVERIFICATION' });
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-red-200">
            <div className="bg-red-50 px-4 py-3 border-b border-red-200 rounded-t-lg">
                <h2 className="text-lg font-semibold text-red-800">Corrective Action Logs</h2>
            </div>
            <div className="p-4 space-y-4">
                <p className="text-red-600 font-bold">Defect/Deviation identified by QA. Enter corrective actions and upload proof pictures below.</p>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 border">
                        <thead className="bg-red-100">
                            <tr>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Defect Description</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">QA Observation details</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Corrective Action Taken</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Upload Corrective Action Proof</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {state.deviations.map((dev, idx) => (
                                <tr key={idx}>
                                    <td className="px-3 py-2 text-sm text-gray-900 font-bold">{dev.defectDesc}</td>
                                    <td className="px-3 py-2 text-sm text-gray-500">{dev.obsDetails}</td>
                                    <td className="px-3 py-2">
                                        <textarea 
                                            className="w-full border-gray-300 rounded-md shadow-sm sm:text-sm p-2 border" 
                                            rows={2} 
                                            placeholder="Describe actions taken..."
                                            value={actions[idx] || ''}
                                            onChange={e => setActions(prev => ({ ...prev, [idx]: e.target.value }))}
                                        ></textarea>
                                    </td>
                                    <td className="px-3 py-2">
                                        <input type="file" accept="image/*" className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-red-50 file:text-red-700 hover:file:bg-red-100" />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="text-right mt-4">
                    <button
                        onClick={handleSubmit}
                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                        Submit to QA for Re-Verification
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CorrectiveActionComponent;
